module.exports = __webpack_public_path__ + "media/szczeniaki_film.a76ac935.mp4";